import { classNames } from '../../lib/classNames'

export default function TagFilter({ allTags, activeTags, onToggle }) {
    if (allTags.length === 0) return null
    return (
        <div className="mt-3 flex flex-wrap gap-1.5">
            {allTags.map((tag) => (
                <button
                    key={tag}
                    onClick={() => onToggle(tag)}
                    className={classNames(
                        'px-2.5 py-1 border-2 text-xs font-semibold uppercase tracking-wide transition-colors',
                        activeTags.has(tag)
                            ? 'bg-accent text-black border-black dark:border-white'
                            : 'bg-white text-black border-black dark:bg-zinc-950 dark:text-white dark:border-white hover:bg-accent/50'
                    )}
                >
                    {tag}
                </button>
            ))}
        </div>
    )
}
